/**
 * Cross-platform CDN helper. Joins an object key to the public read origin
 * (`NEXT_PUBLIC_CDN_URL` / `EXPO_PUBLIC_CDN_URL`, which is the R2 public
 * bucket's domain). Provider-agnostic — it only ever concatenates.
 */
export const getS3ObjectURLShared = (key: string, prefix: string) => {
  // Return as-is if already a full URL or preview URL
  if (
    key.includes('http://') || // Full URLs
    key.includes('https://') || // Full URLs
    key.startsWith('/') || // Local file paths
    key.startsWith('data:') || // Data URLs are used for previewing files
    key.startsWith('blob:') // Blob URLs are used for previewing files
  ) {
    return key;
  }

  return `${prefix}/${key}`;
};
